<template>
    <div id="cart-tip" class="grid-x align-justify tips">
        <div class="cell">
            <p class="display-large semi-bold margin-0">Tip</p>
            <p>100% goes to staff</p>
            <div class="grid-x grid-padding-x align-justify">
                <ul class="cell shrink tips-list margin-0">
                    <li dusk="5-percent" :class="['semi-bold', {active: isActive(5)}]" @click="setTipAmount(5)">
                        <span>5%</span>
                    </li>
                    <li dusk="10-percent" :class="['semi-bold', {active: isActive(10)}]" @click="setTipAmount(10)">
                        <span>10%</span>
                    </li>
                    <li dusk="15-percent" :class="['semi-bold', {active: isActive(15)}]" @click="setTipAmount(15)">
                        <span>15%</span>
                    </li>
                </ul>
                <div class="cell auto">
                    <currency-input
                        dusk="tip-amount"
                        label="Tip amount"
                        label-mobile="Tip"
                        :value="tipAmount"
                        @input="setTipAmount($event, false)"
                    >
                    </currency-input>
                </div>
            </div>
        </div>
    </div>
</template>
<script lang="ts">
import Vue from 'vue';
import Component from 'vue-class-component';
import { getModule } from 'vuex-module-decorators';
import CurrencyInput from '@/components/common/forms/CurrencyInput.vue';
import CartModule from '@/stores/modules/cart';
import TimeSchedulerModule, { OrderRetrievalMethod } from '@/stores/modules/time-scheduler';

@Component({
    components: { CurrencyInput }
})
export default class CartTip extends Vue
{
    cartModule!: CartModule;
    timeSchedulerModule!: TimeSchedulerModule;
    editMode: boolean = false;
    tipPercent: number = 10;

    created() {
        this.cartModule = getModule(CartModule, this.$store);
        this.timeSchedulerModule = getModule(TimeSchedulerModule, this.$store);
    }

    mounted() {
        this.$watch('retrievalMethod', () => {
            this.tipPercent = (this.retrievalMethod === OrderRetrievalMethod.PICK_UP) ? 0 : 10;
            this.setTipAmount(this.tipPercent);
        }, { immediate: true });
        this.$watch('orderTotal', () => {
            if (this.tipPercent) {
                this.cartModule.setTipAmount(this.convertTipPercent(this.tipPercent));
            }
        });
    }

    setTipAmount(tip: number, percent: boolean = true) {
        if (tip) {
            if (percent) {
                this.tipPercent = tip;

                return this.cartModule.setTipAmount(this.convertTipPercent(this.tipPercent));
            }
            this.tipPercent = 0;
      
            return this.cartModule.setTipAmount(parseFloat(tip.toString()));
        }
        return this.cartModule.setTipAmount(0);
    }

    convertTipPercent(percent: number) {
        return (percent * this.cartModule.subtotal) / 100;
    }

    get tipAmount() {
        return this.cartModule.tipAmount.toString();
    }

    get retrievalMethod() {
        return this.timeSchedulerModule.retrievalMethod;
    }

    get orderTotal() {
        return this.cartModule.subtotal + ((this.cartModule.isDelivery) ? this.cartModule.deliveryFee : 0);
    }

    get isActive() {
        return (tip: number) => (tip === this.tipPercent);
    }
}
</script>
<style lang="scss" scoped>
@import '~foundation-sites/scss/foundation';
@import '~scss/front/settings';
.cart-tip {
    input.boxed {
        margin-bottom: 0!important;
    }
}
.tips-list {
    list-style-type: none;
    margin-left: 0;

    li {
        display: inline-block;
        border-radius: 50%;
        width: 60px;
        height: 60px;

        span {
            display: flex;
            align-items: center;
            justify-content: center;
            height: 100%;
            text-align: center;
        }

        &:hover {
            background-color: var(--cart-tip-hover-bg);
            cursor: pointer;
        }
        &.active {
            background-color: var(--cart-tip-selected-bg);
            color: var(--white);
        }
    }
}
</style>